import { GenericFormItemWithLoadingKey } from '../utils';

const awsFields: GenericFormItemWithLoadingKey[] = [
  {
    gridXs: 6,
    label: 'KEY_PAIR_KEY',
    stateKey: 'provider_data.key_pair',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingKeyPairs',
  },
  {
    gridXs: 6,
    label: 'PRIMARY_ZONE_KEY',
    stateKey: 'provider_data.primary_zone',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingZones',
  },
  {
    gridXs: 6,
    label: 'SECONDARY_ZONE_KEY',
    stateKey: 'provider_data.secondary_zone',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingZones',
  },
  {
    gridXs: 6,
    label: 'AMI_KEY',
    stateKey: 'provider_data.image_id',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingImages',
  },
  {
    gridXs: 6,
    label: 'SECURITY_GROUP_KEY',
    stateKey: 'provider_data.security_group',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingSecurityGroups',
  },
  {
    gridXs: 6,
    label: 'FLAVOR_KEY',
    stateKey: 'provider_data.flavor',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingFlavors',
  },
  {
    gridXs: 6,
    label: 'CREDIT_SPECIFICATIONS_KEY',
    stateKey: 'provider_data.credit_specification',
    isSelect: true,
    options: [
      {
        label: 'Standard',
        value: 'standard',
      },
      {
        label: 'Unlimited',
        value: 'unlimited',
      },
    ],
  },
];

export default awsFields;
